import { render, staticRenderFns } from "./SaleDetail.vue?vue&type=template&id=54b678a3&"
import script from "./SaleDetail.vue?vue&type=script&lang=js&"
export * from "./SaleDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54b678a3')) {
      api.createRecord('54b678a3', component.options)
    } else {
      api.reload('54b678a3', component.options)
    }
    module.hot.accept("./SaleDetail.vue?vue&type=template&id=54b678a3&", function () {
      api.rerender('54b678a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/SaleDetail.vue"
export default component.exports